import { Component, inject } from '@angular/core';
import { LeftSideBarV2Component } from '../left-side-bar-v2/left-side-bar-v2.component';
import { ClockWidgetService } from '../usa-timezone-clock/clock-widget.service';
import { NavV2Service } from '../left-side-bar-v2/nav-v2.service';

@Component({
    selector: 'app-layout',
    imports: [
        LeftSideBarV2Component,
    ],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.css'
})
export class LayoutComponent {
  readonly clockWidget = inject(ClockWidgetService);
  readonly nav = inject(NavV2Service);
}
